import { Api } from "@/core/api.js";
const api = new Api();

// initial state
const state = {
  exp: -1,
  login: null,
  list: [],
  total_list: 0,
  pagination: { num_page: 0, num_items: 20 },
  current_filters: {},
  rel_event_entity_list: []
};

// getters
const getters = {
  getTotalList: (state, getters, rootState) => () => {
    return state.total_list;
  },

  getList: (state) => (id) => {
    var data = [];
    for (var i in state.list) {
      if (state.list[i].visible) data.push(state.list[i]);
    }
    return data;
  },

  getListNoFiltered: (state, getters, rootState) => () => {
    var data = [];
    for (var i in state.list) {
      data.push(state.list[i]);
    }
    return data;
  },

  get_by_id: (state, getters, rootState) => (id) => {
    if (typeof state.list[id] !== "undefined") {
      var volunteer = state.list[id];
      return volunteer;
    }
    return false;
  },
};

const actions = {
  loadList({ commit, state }, params) {
    var path =
      (typeof params !== "undefined" &&
      typeof params.event !== "undefined" &&
      params.event != null
        ? "team/completion-list/event/" + params.event
        : "");
    var page_options =
      params && params.page_options ? params.page_options : state.pagination;
    var filters =
      params && params.filters ? params.filters : state.current_filters;
    var oParams = Object.assign(filters ? filters : {}, page_options);

    return api.post(path, oParams).then(function (response) {
      if (response.status) {
        var data = response.data.data;
        for (var i in data) {
          data[i].visible = true;
        }

        commit("setList", { data: data, total: response.data.total });
        return commit("setPagination", page_options);
      }
    });
  },

  load_by_id({ commit }, params) {
    var path = "hotel-app/" + params.id;
    return api.get(path).then(function (response) {
      if (response.status) {
        var data = response.data;
        data.visible = true;

        return commit("addVolunteer", data);
      }
    });
  }
};
const mutations = {
  setList(state, data) {
    state.list = data.data;
    state.total_list = data.total;
  },

  setState(state, data) {
    state.states_volunteer = data;
  },

  addNote(state, { id, note }) {
    var list = { ...state.list };
    list[id].notes[note.id] = note;

    state.list = list;
  },

  applyFilters(state, filters) {
    // var list = {...state.list};
    // if( !filters ){
    //     for( var i in list ){
    //         list[ i ].visible = true;
    //     }
    // }
    // else {
    //     for( var i in list ){
    //         list[ i ].visible = false;
    //     }
    //     for( var i in list ){
    //         var item = list[ i ];
    //         var bFound = true;
    //         var bEventFound = typeof filters['event'] === 'undefined';
    //         for( var k in filters ){

    //             if( filters[k] != -1 ){
    //                 var item_value = ( item[k] != null && typeof item[k] == 'object' )? item[k].id : item[k];
    //                 if( item.hasOwnProperty( k ) && filters[k] == null && item_value == null ){

    //                 } else {

    //                     if( filters[k] != null && typeof filters[k] === 'boolean' ) filters[k] = filters[k] ? 1 : 0
    //                     else if( filters[k] != null && typeof filters[k] === 'string' ) filters[k] = filters[k].trim()

    //                     var regexp = new RegExp( filters[k], "gi" );

    //                     if( item.hasOwnProperty( k ) && typeof item[k] == 'object' && filters[ k ] != item_value ) {
    //                     bFound = false;
    //                     }
    //                     else if( item.hasOwnProperty( k ) && typeof item[k] !== 'object' && !item_value.match( regexp ) ){
    //                         bFound = false;
    //                     }

    //                     if( k == 'event' && item.event != null ){
    //                         item.event.forEach( event => {
    //                         if( event.id[0] == filters[k] ){
    //                                 bFound = true;
    //                             }
    //                         })
    //                     } else if (filters[k] == 1){
    //                         bFound = true;
    //                     }

    //                     if( k == 'idiomas' && item.idiomas != null ){
    //                         typeof item.idiomas === 'string' ? item.idiomas=JSON.parse(item.idiomas.split(',')[0]+',"level":"Alt"}]'):true;
    //                         item.idiomas.forEach( lang => {
    //                         if( lang.lang == filters[k] ){
    //                                 bFound = true;
    //                             }
    //                         })
    //                     } else if (filters[k] == 1){
    //                         bFound = true;
    //                     }
    //                 }
    //             }
    //             list[ i ].visible = bFound;
    //         }
    //     }
    // }

    // state.list = list;
    state.current_filters = filters;
  },
  setPagination(state, value) {
    state.pagination = value;
  },
  setRelEventEntityList(state, { data }) {
    state.rel_event_entity_list = data;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
